import stripeBadge from '../../../assets/img/stripe-badge.svg';
const Footer = () => {
  return (
    <footer>
      <ul>
        <li><a href="https://teachon.org/terms/">Terms</a></li>
        <li><a href="https://teachon.org/privacy/">Privacy</a></li>
      </ul>
      <br />
      <img src={stripeBadge} 
        style={{height:"40px"}}
        />
      <div><br/></div>
      
    </footer>
  )
}
export default Footer
